import { Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ENavigationRoute } from '../model/enum/navigation-route';
import { CoreData } from './core-data/core-data';
import { ENavigationErrorType } from '../model/enum/navigation-error-type';

@Injectable()
export class LoginGuard  {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        if (!this.coreData.IsLoggedIn) {
            return this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
        }

        const url = route.url[0] === undefined ? ENavigationRoute.Home : route.url[0].path;
        return (this.coreData.IsLoggedIn && this.hasPermission(url) ||
            (url !== ENavigationRoute.Home && this.router.parseUrl('/' + ENavigationRoute.Home))) || this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }]);
    }

    hasPermission(url: string) {
        switch (url) {
            case ENavigationRoute.Home:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.Order:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.Strategy:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.StrategyDetail:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.IntenventionList:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.Config:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.Budget:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.Agency:
                if (this.coreData.User) {
                    return true;
                }
                break;
        }
        return false;
    }
}

